import { z } from 'zod';

/**
 * GET questions/employer_industry/
 */

export const ZodEmployerIndustryTypeV1 = z.enum([
  'accounting',
  'admin/secretarial',
  'army/army_industry',
  'auctions',
  'catering/hospitality',
  'creative/media',
  'education',
  'emergency_services',
  'engineering',
  'financial_services',
  'gas/petrol',
  'health/medicine',
  'hr',
  'insurance',
  'legal',
  'leisure/tourism',
  'manufacturing',
  'marketing/pr/advertising',
  'pharmaceuticals',
  'precious_metals/diamonds',
  'property_construction/real_estate',
  'retail',
  'sales',
  'social_care/services',
  'telecommunications',
  'transport/logistics',
  'virtual_currency',
]);

export type EmployerIndustryTypeV1 = z.infer<typeof ZodEmployerIndustryTypeV1>;

export const EmployerIndustryTypeV2Values = [
  'agriculture',
  'art',
  'charities',
  'construction/real_estate',
  'defence/security',
  'finance',
  'gambling',
  'hospitality',
  'legal/accountancy',
  'logistics',
  'manufacturing',
  'medical',
  'mining',
  'other',
  'pharmaceuticals',
  'public_sector',
  'religion',
  'remittance/technical_equipment',
  'retail',
  'retired',
  'self-employed',
  'student',
  'tourism',
  'unemployed',
  'unregulated_crypto',
] as const;

export const ZodEmployerIndustryTypeV2 = z.enum(EmployerIndustryTypeV2Values);

export type EmployerIndustryTypeV2 = z.infer<typeof ZodEmployerIndustryTypeV2>;

export const EmployerIndustryTypeV3Values = [
  'accommodation_and_food_services',
  'accountancy_services',
  'administrative_and_support_services',
  'adult_entertainment',
  'agriculture',
  'arms_defense_and_private_security',
  'art_entertainment_and_recreation',
  'auctions',
  'cbd_business',
  'construction',
  'education',
  'energy',
  'financial_and_insurance_services',
  'gambling_casinos_and_online_betting',
  'health_medicine_and_social_care',
  'human_resources_services',
  'information_and_communication',
  'legal_and_consulting',
  'manufacturing',
  'merchant_services',
  'mining_and_oil_activities',
  'precious_stones_and_metals',
  'professional_scientific_and_technical_services',
  'property',
  'public_sector',
  'real_estate_agency_and_renting',
  'remittance_and_money_service_business',
  'retail_services',
  'sects_cults_and_religion',
  'supply_chain_management',
  'technology_services',
  'tourism_and_travel',
  'trading_unregulated_financial_and_crypto_services',
  'transport_storage_and_logistics',
  'trust_charities_and_foundations',
  'vehicle_trade_and_repair',
  'water_supply_sewerage_and_waste_management',
  'asset_holding_company',
] as const;

export const ZodEmployerIndustryTypeV3 = z.enum(EmployerIndustryTypeV3Values);

export type EmployerIndustryTypeV3 = z.infer<typeof ZodEmployerIndustryTypeV3>;

export const ZodAllEmployerIndustries = z.union([
  ZodEmployerIndustryTypeV1,
  ZodEmployerIndustryTypeV2,
  ZodEmployerIndustryTypeV3,
]);

export type AllEmployerIndustries = z.infer<typeof ZodAllEmployerIndustries>;

export const ZodLatestEmployerIndustryType = ZodEmployerIndustryTypeV3;

export type LatestEmployerIndustryType = z.infer<typeof ZodLatestEmployerIndustryType>;
